import axios, { AxiosError } from 'axios';
import { DO_CENTRAL_SERVICE_URL } from '../constants/AppConstants';
import { Dictionary } from '../types/utils.types';

const REDIRECTION_URL: Dictionary<string> = {
  401: `${DO_CENTRAL_SERVICE_URL}/login`,
  403: `${DO_CENTRAL_SERVICE_URL}/login`,
  404: `/`,
};

export function errorHandler(error: any, skipRedirect = false): string | null {
  if (axios.isAxiosError(error)) {
    const { response } = error;
    if (response && response.status) {
      const { status } = response;
      // const code = response?.data?.code;
      const redirectionUrl = REDIRECTION_URL[status];
      let next;
      if ([401].includes(status)) {
        next = `?next=${window.location.href}`;
      }
      if (redirectionUrl && !skipRedirect) {
        window.location.replace(`${redirectionUrl}${next ? next : ''}`);
        return null;
      }
      const message = response?.data?.message;
      if (message) return message;
    }
  }
  return null;
}
